(() => {
  gsBuilderBanner = {
    state: {
      bannerUrl: "https://cdn.shopify.com/s/files/1/2616/9618/files/Inner_page_desktop.jpg?v=1740159407", /*** IMAGE URL HERE ***/
      bannerAlt: "Snackbox with various snacks and nuts around"  /*** ALT TEXT HERE ***/
    },
    init: function () {
      if (!this.state.bannerUrl) {
        console.warn("Banner URL not set.");
        return;
      }
  
      this.events();
    },
    events: function() {
      const that = this;
      window.addEventListener("DOMContentLoaded", function(e) {
        that.handleBanner(e);
      });
    },
    handleBanner: function(e) {
      const gsBuilderRoot = document.getElementById('boxBuilderRoot');
      const parentNode = gsBuilderRoot && gsBuilderRoot.parentNode;
  
      if (gsBuilderRoot && parentNode) {
        const bannerEl = document.createElement('img');
        bannerEl.src = this.state.bannerUrl;
        bannerEl.setAttribute('alt', this.state.bannerAlt);
  
        const wrapperEl = document.createElement('div');
        wrapperEl.className = "gs__box-builder-banner";
        wrapperEl.appendChild(bannerEl);
  
        parentNode.insertBefore(wrapperEl, gsBuilderRoot);
      }
    
    }
  };
  gsBuilderBanner.init();
})();